
import React, { useState, useEffect } from 'react';

import { loginRequest, protectedResources } from "../../authConfig";
//import { useGetSkillData, useUpdateSkillData } from '../../hooks/useSkillData';
import { ISkill } from '../../model/Skill.model';
import { IsCookieFunction } from 'react-router-dom';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { ISkillGroup } from '../../model/SkillGroup.model';
import { ISkillPath } from '../../model/SkillPath.model';
import "./AddSkillPathFormComponent.scss";

const AddSkillPathFormComponent: React.FC<{
  parentSkillPathId: number;
  maxIndex: number;
  newSkillPathCreated(event: ISkillPath): void;
}> = (props: {
  parentSkillPathId: number;
  maxIndex: number;
  newSkillPathCreated(event: ISkillPath): void;
}) => {
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);

    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const now = (new Date()).toISOString();
      var sp: ISkillPath = {
        //skillGroupId: -1,
        parentSkillPathId: props.parentSkillPathId + "",
        skillPathId: "",
        indexNumber: props.maxIndex + 1,
        skillPathName: formData.get("skillPathName") + "",
        skillPathDescription: formData.get("skillPathDescription") + "",
        highlightColor: "#f26829",
        createdDate: now,
        CreatedBy: "me",
        lastModifiedDate: now,
        lastModifiedBy: "me",
        skillGroups: [],
        skillLevels: [],
        subSkillPaths: []
      }
      if (sp.skillPathDescription.indexOf('<') < 0) {
        sp.skillPathDescription = '<p>' + sp.skillPathDescription + '</p>';
      }

      execute("POST", `/api/SkillPath/addSkillPath`, sp)
        .then((response: any) => {
          //console.log('api call success');
          props.newSkillPathCreated(response);
          setLoading(false);
        }).catch((err: any) => {
          setErr(err);
          setLoading(false);
        })
    }
    return (
      <>
        <div>
          <form onSubmit={HandleSubmit}>
            <div className='modal-form-content-scroll-container add-skill-path-form-container'>
              <div className="form-group m-b-1">
                <label htmlFor="skillPathName">Name</label>
                <input id="skillPathName" type='text' name='skillPathName' />
              </div>
              <div className="form-group m-b-1">
                <label htmlFor="skillPathDescription">Description</label>
                <input id="skillPathDescription" type='text' name='skillPathDescription' />
              </div>
            </div>
            <div className="modal-form-button-container">
              <button className="btn-secondary" type='submit'>Submit New Skill Path</button>
            </div>
          </form>
        </div>
      </>
    )
  }







export default AddSkillPathFormComponent;
